import type { AuthSession, AuthUser, PasswordLogin } from '@pms/shared';

import { getDeviceId } from '../sync/db.js';
import { request } from '../sync/api.js';

const TIMEOUT_MS = 20_000;

export async function loginWithPassword(input: PasswordLogin): Promise<AuthSession> {
  const deviceId = await getDeviceId();
  return request<AuthSession>(
    '/api/auth/login',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Device-Id': deviceId },
      body: JSON.stringify(input),
    },
    TIMEOUT_MS,
  );
}

export async function fetchMe(): Promise<AuthUser> {
  const body = await request<{ user: AuthUser }>('/api/auth/me', { method: 'GET' }, TIMEOUT_MS);
  return body.user;
}

export async function logoutOnServer(): Promise<void> {
  await request<{ ok: boolean }>(
    '/api/auth/logout',
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' },
    TIMEOUT_MS,
  );
}
